import { render, staticRenderFns } from "./GroupPresetCard.vue?vue&type=template&id=bd39e986"
import script from "./GroupPresetCard.vue?vue&type=script&lang=js"
export * from "./GroupPresetCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports